import { YouTubeVideo } from './platforms/you-tube-video'
import { VideoBlock } from './video.block'

export const VideoComponent = (block: VideoBlock) => {
  switch (block.platform) {
    case 'youtube':
      return <YouTubeVideo {...block} />

    default:
      console.warn(`Unsupported video platform: ${block.platform}`)
      return null
  }
}
